
import { Icon } from "@iconify/react";
import React, { useState } from "react";

export default function CustomImageUpload({ value, path, onChange, name }) {
  const [product_img, setproduct_img] = useState(null);

  return (
    <div className="flex items-center justify-center h-full w-full">
      {value || path || product_img ? (
        <div className="flex flex-col items-center w-full">
          <img
            src={
              product_img
                ? URL.createObjectURL(product_img)
                : path
                ? path
                : "https://ftcdc.udru.ac.th/ftcdc-api/storage/app/public/upload/UploadImg/" +
                  value
            }
            className="h-[300px] w-full object-cover rounded-md"
          />
          <div
            onClick={() => {
              onChange(null);
              setproduct_img(null);
            }}
            className=" cursor-pointer absolute bottom-3 bg-white rounded-md drop-shadow-lg px-2 py-1 flex flex-row items-center text-black hover:bg-[#9E0400] hover:text-white"
          >
            <Icon icon={"uil:image-times"} className=" text-lg" />
            <span>ลบ</span>
          </div>
        </div>
      ) : (
        <div
          onClick={() => {
            document.getElementById(name).click();
          }}
          className=" cursor-pointer flex flex-col items-center "
        >
          <Icon icon={"uil:image-plus"} className="text-black text-3xl" />
          <p>เพิ่มภาพ</p>
        </div>
      )}
      <input
        onChange={(e) => {
          if (e.target.files.length > 0) {
            setproduct_img(e.target.files[0]);
            onChange(e.target.files[0]);
          }
        }}
        type="file"
        className="hidden"
        name={name}
        id={name}
        accept=".png, .jpg, .jpeg"
        multiple={true}
        max={1}
        maxLength={1}
      />
    </div>
  );
}
